<template>
  <div class="muicy-box">
    <div class="PlayEy"></div>
    <div class="Btn"></div>
    <div class="Play">
      <audio
        id="audios"
        :src="domianURL+'/'+musicpath"
        loop="true"
        autoplay="true"
      ></audio>
    </div>
  </div>
</template>

<script>
import { getAction } from '@/api/manage'
export default {
  mounted() {
    this.lodata();
  },
  data() {
    return {
      musicpath: ''
    }
  },
  methods: {
    lodata() {
      var i = 0;
      var oPlay = document.getElementsByClassName("Play")[0];
      var oPlayEy = document.getElementsByClassName("PlayEy")[0];
      var audios = document.getElementById("audios");
      oPlay.onclick = function () {
        var seii = setInterval(function () {
          i == 360 ? (i = 0) : i++;
          oPlayEy.style.transform = "rotate(" + i + "deg)";
          if (audios.paused) {
            clearInterval(seii);
          }
        }, 30);
        if (audios.paused) {
          audios.play();
          oPlay.style.backgroundImage = "url(/image/play.png)";
        } else {
          audios.pause();
          oPlay.style.backgroundImage = "url(/image/pause.png)";
        }
      };
      getAction('/act/music/queryById',{
        id: '1357275759063891969'
      }).then(res => {
        if(res.success){
          this.musicpath = res.result.musicLocal
        }
      })
    },
  },
};
</script>

<style lang="scss" >
.muicy-box {
  position: fixed;
  top: 4.5%;
  left: 1%;
}
.Btn {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  background-color: yellow;
  background: url(/image/bg_circle.png) no-repeat;
  background-size: 100% 100%;
  animation: Btn-bg 3s linear infinite;
}

.Play {
  width: 14px;
  height: 14px;
  background: red;
  background: url(/image/play.png) no-repeat;
  background-size: 100% 100%;
  transition: 0.4s;
  position: relative;
  top: 13px;
  left: 12px;
  animation: Btn-bg 3s linear infinite;
}
@keyframes Btn-bg {
  from {
  }
  to {
    transform: rotate(360deg);
  }
}
</style>